import React, { useEffect, useState } from "react";
import UserView from "./UserView";
import { useNavigate } from 'react-router-dom';
import ApiHelper from "../../api/api_helper";
import LoadingIndicator from "../loading/LoadingIndicator";
import { useDialog } from "../../context/dialog_context";
import {
    Dialog,
    DialogContent,
    DialogActions,
    Button,
    Typography,
} from "@mui/material";

const UserController = () => {
    const [selectRole, setSelectRole] = useState('survey');
    const [listUser, setListUser] = useState([]);
    const [, setApiError] = useState('');
    const [isLoading, setIsLoading] = useState(true);
    const [page, setPage] = useState(0);
    const [deleteTarget, setDeleteTarget] = useState(null);
    const { showDialog } = useDialog();

    const navigate = useNavigate();

    // Init state
    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(() => { getListUser(selectRole) }, []);

    // Define Table Columns
    const tableColumns = [
        { id: '1', label: 'ลำดับ', minWidth: 50, key: "order" },
        { id: '2', label: 'ชื่อ - นามสกุล', minWidth: 100, key: "firstname" },
        { id: '3', label: 'เบอร์โทรศัพท์', minWidth: 100, key: "telephone" },
        { id: '4', label: 'ชื่อผู้ใช้งาน', minWidth: 100, key: "username" },
        { id: '5', label: 'การจัดการ', minWidth: 100, key: "Action" },
    ];

    // Change Page
    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    // Fetch User Data
    const getListUser = async (role) => {
        setSelectRole(role);
        try {
            setIsLoading(true);
            const response = await ApiHelper.get(`/auth/users?role=${role}`);
            if (response.status !== 200) {
                throw response;
            }
            setListUser(response.data.data);

        } catch (error) {
            setApiError(error.data);
        } finally {
            setIsLoading(false);
        }
    }

    // Go to add user screen
    const onClickAddButton = () => {
        navigate('/user/add')
    }

    // Go to edit user by id
    const onClickEditButton = (userId) => {
        navigate(`/user/${userId}/change`)
    }

    // Delete user
    const onClickDeleteButton = (user) => {
        setDeleteTarget(user);
    }

    const handleCloseDeleteDialog = () => {
        setDeleteTarget(null);
    }

    const submitDeleteUser = async () => {
        const target = deleteTarget;
        setDeleteTarget(null);
        try {
            setIsLoading(true);
            const response = await ApiHelper.delete(`/auth/user/${target.id}`);
            if (response.status !== 200) {
                throw response;
            }
            showDialog('สำเร็จ', `ลบสมาชิก ${target.username} เรียบร้อย`);
        } catch (error) {
            showDialog('เกิดข้อผิดพลาด', error?.data?.data || 'ไม่สามารถลบสมาชิกได้');
        } finally {
            getListUser(selectRole);
        }
    }

    // If loading show loading screen
    if (isLoading) {
        return <LoadingIndicator />
    }

    return <div>
    <UserView
        selectRole={selectRole}
        getListUser={getListUser}
        listUser={listUser}
        tableColumns={tableColumns}
        handleChangePage={handleChangePage}
        page={page}
        onClickAddButton={onClickAddButton} 
        onClickEditButton={onClickEditButton}
        onClickDeleteButton={onClickDeleteButton}
    />
    <Dialog open={Boolean(deleteTarget)} onClose={handleCloseDeleteDialog}>
        <DialogContent>
            <Typography sx={{ fontWeight: "bold", fontSize: 24, textAlign: "center" }}>
                ต้องการลบสมาชิกนี้ ?
            </Typography>
            <Typography sx={{ textAlign: "center", mt: 1 }}>
                {deleteTarget ? `${deleteTarget.firstname} ${deleteTarget.lastname} (${deleteTarget.username})` : ''}
            </Typography>
        </DialogContent>
        <DialogActions>
            <Button
                variant="contained"
                sx={{
                    color: "white",
                    borderRadius: "10px",
                    backgroundColor: "#ED5768",
                    "&:hover": { backgroundColor: "#ED5768" },
                }}
                onClick={handleCloseDeleteDialog}
            >
                ยกเลิก
            </Button>
            <Button
                variant="contained"
                sx={{
                    color: "white",
                    borderRadius: "10px",
                    backgroundColor: "#4AAEAF",
                    "&:hover": { backgroundColor: "#4AAEAF" },
                }}
                onClick={submitDeleteUser}
            >
                ยืนยัน
            </Button>
        </DialogActions>
    </Dialog>
    </div>
}

export default UserController